/**
 * Configuración de constantes de la aplicación
 * 
 * NOTA: API_BASE_URL se define en assets/js/scripts/control.js
 * Este archivo solo exporta BASE_PATH y otras constantes de rutas
 */

// Importar API_BASE_URL desde control.js para mantener consistencia
import { API_BASE_URL } from '../assets/js/scripts/control';

// Re-exportar para compatibilidad con código existente
export { API_BASE_URL };

export const BASE_PATH = process.env.REACT_APP_BASE_PATH || '/ligaincom';
export const IS_PRODUCTION = process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.NODE_ENV === 'production';

// Rutas absolutas (para usar en Links, navigate, etc.) - incluyen BASE_PATH
export const ROUTES = {
  HOME: BASE_PATH,
  MEMBERS: `${BASE_PATH}/integrantes`,
  ADMIN: `${BASE_PATH}/admin`,
  ARTICLES: `${BASE_PATH}/divulgacion`,
  PROJECTS: `${BASE_PATH}/proyectos`,
  PUBLICATIONS: `${BASE_PATH}/publicaciones`,
  TALKS: `${BASE_PATH}/congresos_seminarios`,
  COURSES: `${BASE_PATH}/cursos`,
  BD: `${BASE_PATH}/bd`,
  BD_LOGIN: `${BASE_PATH}/bd/login`,
  BD_MOVIES: `${BASE_PATH}/bd/peliculas`,
  BD_SERIES: `${BASE_PATH}/bd/series`,
  BD_TAGS: `${BASE_PATH}/bd/etiquetas`,
  BD_FAVORITES: `${BASE_PATH}/bd/favoritos`,
  BD_REQUESTS: `${BASE_PATH}/bd/requests`,
  DETAILS: {
    COURSE: (id) => `${BASE_PATH}/detalles/curso/${id}`,
    ARTICLE: (id) => `${BASE_PATH}/detalles/articulo/${id}`,
    TALK: (id) => `${BASE_PATH}/detalles/congreso/${id}`,
    PROJECT: (id) => `${BASE_PATH}/detalles/proyecto/${id}`,
    PUBLICATION: (id) => `${BASE_PATH}/detalles/publicacion/${id}`,
    MOVIE: (id) => `${BASE_PATH}/bd/detalles/pelicula/${id}`,
    SERIES: (id) => `${BASE_PATH}/bd/detalles/serie/${id}`,
  },
};

// Rutas relativas (para usar en <Route path={}> components) - NO incluyen BASE_PATH
// porque el BrowserRouter ya tiene basename={BASE_PATH}
export const ROUTE_PATHS = {
  HOME: '',
  MEMBERS: '/integrantes',
  ADMIN: '/admin',
  ARTICLES: '/divulgacion',
  PROJECTS: '/proyectos',
  PUBLICATIONS: '/publicaciones',
  TALKS: '/congresos_seminarios',
  COURSES: '/cursos',
  BD: '/bd',
  BD_LOGIN: '/bd/login',
  BD_MOVIES: '/bd/peliculas',
  BD_SERIES: '/bd/series',
  BD_TAGS: '/bd/etiquetas',
  BD_FAVORITES: '/bd/favoritos',
  BD_REQUESTS: '/bd/requests',
  DETAILS: {
    COURSE: '/detalles/curso/:idcourse',
    ARTICLE: '/detalles/articulo/:idarticle',
    TALK: '/detalles/congreso/:idtalk',
    PROJECT: '/detalles/proyecto/:idproject',
    PUBLICATION: '/detalles/publicacion/:idpublication',
    MOVIE: '/bd/detalles/pelicula/:idMovie',
    SERIES: '/bd/detalles/serie/:idSeries',
  },
  // Rutas para <Link to={}>: path sin BASE_PATH para que el Router las combine bien con basename
  DETAIL_LINK: {
    COURSE: (id) => '/detalles/curso/' + id,
    ARTICLE: (id) => '/detalles/articulo/' + id,
    TALK: (id) => '/detalles/congreso/' + id,
    PROJECT: (id) => '/detalles/proyecto/' + id,
    PUBLICATION: (id) => '/detalles/publicacion/' + id,
    MOVIE: (id) => '/bd/detalles/pelicula/' + id,
    SERIES: (id) => '/bd/detalles/serie/' + id,
  },
};

